import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  HotelPageSettingsDto,
  BulkUpdateHotelPageSettingsDto,
  AvailablePageDto,
} from "../types/pageSettings.types";

export class HotelPageSettingsService extends BaseService {
  private readonly basePath = "/api/admin/hotel-page-settings";

  async getHotelPageSettings(): Promise<ApiResult<HotelPageSettingsDto[]>> {
    return this.handleRequest<HotelPageSettingsDto[]>(
      this.client.get<HotelPageSettingsDto[]>(this.basePath),
    );
  }

  async getAvailablePages(): Promise<ApiResult<AvailablePageDto[]>> {
    return this.handleRequest<AvailablePageDto[]>(
      this.client.get<AvailablePageDto[]>(`${this.basePath}/available-pages`),
    );
  }

  async updateHotelPageSettings(
    dto: BulkUpdateHotelPageSettingsDto,
  ): Promise<ApiResult<void>> {
    return this.handleRequest<void>(this.client.put(this.basePath, dto));
  }

  async getDisabledPages(): Promise<ApiResult<string[]>> {
    return this.handleRequest<string[]>(
      this.client.get<string[]>(`${this.basePath}/disabled-pages`),
    );
  }
}
